import Vue from "vue";
import VueRouter from "vue-router";

import Overview from "@/views/pages/Overview.vue";
import Customer from "@/views/pages/Customer.vue";
import CustomerComplaint from "@/views/pages/CustomerComplaint.vue";
import CustomerComplaint2 from "@/views/pages/CustomerComplaint2.vue";
import CustomerReport from "@/views/pages/CustomerReport.vue";
import CustomerReport2 from "@/views/pages/CustomerReport2.vue";
import CustomerReport3 from "@/views/pages/Customer/CustomerReport.vue";
import CustomerSinergi from "@/views/pages/Sinergi.vue";

//FUEL
import Fuel from "@/views/pages/Fuel.vue";
// import FuelOutlet from '@/views/pages/FuelOutlet.vue'
import FuelOutlet2 from "@/views/pages/FuelOutlet2.vue";
import FuelReport2 from "@/views/pages/FuelReport2.vue";
import FuelReport from "@/views/pages/FuelReport.vue";
import FuelTracking from "@/views/pages/FuelTracking.vue";
import Satgas from "@/views/pages/Satgas.vue";
// import SatgasReport from '@/views/pages/SatgasReport.vue'
import SatgasReport2 from "@/views/pages/SatgasReport2.vue";
import SatgasReportCNT from "@/views/pages/SatgasReportCNT.vue";
import FuelJBT from "@/views/pages/FuelJBT.vue";

import FuelCoco from "@/views/pages/FuelCoco.vue";
import FuelKso from "@/views/pages/FuelKso.vue";
import FuelTac from "@/views/pages/FuelTac.vue";
import FuelMarginTac from "@/views/pages/FuelMarginTAC.vue";

//DO Outstanding
import FuelDOOutstanding from "@/views/pages/Fuel/DOOutstanding/FuelDOOutstanding.vue";
import FuelDOOutstandingReport from "@/views/pages/Fuel/DOOutstanding/Report/Report.vue";

//khusus untuk vendor (UJB)
import SatgasMonitorVendor from "@/views/pages/SatgasMonitorVendor.vue";

//Khusus untuk Pertamina Pusat (C&T)
// import SatgasCNT from '@/views/pages/SatgasCNT.vue'

import Bright from "@/views/pages/Bright.vue";
import BrightSales from "@/views/pages/BrightSales.vue";
import BrightStore from "@/views/pages/BrightStore.vue";
import BrightStoreList from "@/views/pages/BrightStoreList.vue";
import BrightStock from "@/views/pages/BrightStock.vue";
import BrightSL from "@/views/pages/BrightSL.vue";
// import BrightReport from '@/views/pages/BrightReport.vue'
import BrightReport2 from "@/views/pages/BrightReport2.vue";
import BrightPerformance from "@/views/pages/BrightPerformance.vue";
import BaselineComparison from "@/views/pages/BaselineComparison.vue";

import BrightStoreTracking from "@/views/pages/BrightStore/BrightStoreTracking/BrightStoreTracking.vue";
import BrightStorePerformance from "@/views/pages/BrightStore/BrightStorePerformance/BrightStorePerformance.vue";
import BrightOtherIncome from "@/views/pages/BrightStore/OtherIncome.vue";

import Cafe from "@/views/pages/Cafe.vue";
import CafeSales from "@/views/pages/CafeSales.vue";
import CafeList from "@/views/pages/CafeList.vue";
import CafeReport from "@/views/pages/CafeReport.vue";

import LPG from "@/views/pages/LPG.vue";
import LPGReport from "@/views/pages/LPGReport.vue";
import LPGReport2 from "@/views/pages/LPGReport2.vue";
import BrimolaClearing from "@/views/pages/BrimolaClearing.vue";
import KliringVAPangkalanLPG from "@/views/pages/KliringVAPangkalanLPG.vue";
import LPGKeagenan from "@/views/pages/LPGKeagenan.vue";

// import Maintenance from '@/views/pages/Maintenance.vue'
// import MaintenanceReport from '@/views/pages/MaintenanceReport.vue'
import Maintenance from "@/views/pages/Maintenance/Maintenance.vue";
import MaintenanceReport2 from "@/views/pages/MaintenanceReport2.vue";
import MaintenanceOperation from "@/views/pages/MaintenanceOperation.vue";
import MaintenanceReportVendor from "@/views/pages/MaintenanceReportVendor.vue";

import Plant from "@/views/pages/Plant.vue";
import PlantSatgas from "@/views/pages/PlantSatgas.vue";
import PlantSatgasVendor from "@/views/pages/PlantSatgasVendor.vue";
import PlantStation from "@/views/pages/PlantStation.vue";
import PageNotFound from "@/views/pages/404.vue";

import Vendor from "@/views/pages/Vendor.vue";
import VendorReport from "@/views/pages/VendorReport.vue";

import Piutang from "@/views/pages/Finance/Piutang/Piutang.vue";

//import Finance from '@/views/pages/Finance.vue'
// import FinanceReport from '@/views/pages/FinanceReport.vue'
import FinanceReport2 from "@/views/pages/FinanceReport2.vue";
import Treasury from "@/views/pages/Treasury.vue";
import TreasuryIncome from "@/views/pages/TreasuryIncome.vue";
import TreasuryOutcome from "@/views/pages/TreasuryOutcome.vue";

//New Treausry
import TreasuryOverview from "@/views/pages/Finance/Treasury/Treasury.vue";
import TreasuryCashFlow from "@/views/pages/Finance/Treasury/CashFlow.vue";
import TreasuryDailyBalance from "@/views/pages/Finance/Treasury/SaldoHarian.vue";

import PencapaianPertumbuhanOutlet from "@/views/pages/LaporanKinerja/PencapaianPertumbuhanOutlet.vue";
import PencapaianPertumbuhanOutletNonFuel from "@/views/pages/LaporanKinerja/PencapaianPertumbuhanOutletNonFuel.vue";
import PerformanceMainPage from "@/views/pages/LaporanKinerja/MainPage.vue";
import PerformanceSalesVolume from "@/views/pages/LaporanKinerja/SalesVolume.vue";
import PerformanceLossesByProduct from "@/views/pages/LaporanKinerja/LossesByProduct.vue";
import PerformanceKeuanganKosolidasi from "@/views/pages/LaporanKinerja/KeuanganKonsolidasi.vue";
import PerformanceRevenueLaba from "@/views/pages/LaporanKinerja/RevenueLaba.vue";
import PerformanceKinerjaFinancial from "@/views/pages/LaporanKinerja/KinerjaFinancial.vue";
import PerformanceKinerjaFinancialNonFuel from "@/views/pages/LaporanKinerja/KinerjaFinancialNonFuel.vue";
import PerformanceTingkatKesehatan from "@/views/pages/LaporanKinerja/TingkatKesehatanPerusahaan.vue";
import PerformanceRasioKeuangan from "@/views/pages/LaporanKinerja/RasioKeuangan.vue";
import PerformanceRealisasiABO from "@/views/pages/LaporanKinerja/RealisasiABO.vue";
import PerformanceRealisasiCAPEX from "@/views/pages/LaporanKinerja/RealisasiCAPEX.vue";
import PerformanceSalesAndLosses from "@/views/pages/LaporanKinerja/SalesAndLosses/SalesAndLosses.vue";
import PerformanceProfitAndLaba from "@/views/pages/LaporanKinerja/ProfitAndLaba/ProfitAndLaba.vue";
import PencapaianPertumbuhanIntro from "@/views/pages/LaporanKinerja/Intro.vue";
import PencapaianPertumbuhanEnd from "@/views/pages/LaporanKinerja/End.vue";

import HSSE from "@/views/pages/HSSE.vue";
import HSSEActionTracking from "@/views/pages/HSSEActionTracking.vue";

import Merchandise from "@/views/pages/Merchandise.vue";
import MerchandiseReport from "@/views/pages/MerchandiseReport.vue";

import Hrga from "@/views/pages/Hrga.vue";
import HrgaReport from "@/views/pages/HrgaReport.vue";

import SupplyChain from "@/views/pages/SupplyChain.vue";
import SupplyChainReport from "@/views/pages/SupplyChainReport.vue";
import SupplyChainItemQuotaReport from "@/views/pages/SupplyChainItemQuotaReport.vue";

import FinancialReportGroup from "@/views/pages/FinanceReportGroup.vue";
import FinancialGroupOverview from "@/views/pages/FinanceGroupOverview.vue";

import FinanceMonitoringCogs from "@/views/pages/FinanceMonitoringCogs.vue";
import DashboardItem from "@/views/pages/DashboardItem.vue";

//Finance -> PL Unit
import PLUnit from "@/views/pages/Finance/PLUnit/PLUnitOv.vue";
import PLUnitReport from "@/views/pages/Finance/PLUnit/PLUnitReport.vue";
import PLUnitVolumeVSRKAP from "@/views/pages/Finance/PLUnit/PLUnitAchievement.vue";
import PLUnitLaporanManajemen from "@/views/pages/Finance/PLUnit/PLUnitLaporanManajemen.vue";

//CNT
import OverviewCnt from "@/views/pages/Cnt/Overview.vue";
import BaselineComparisonCnt from "@/views/pages/Cnt/BaselineComparison.vue";
import BrightReportCnt from "@/views/pages/Cnt/BrightReport2.vue";
import BrightCnt from "@/views/pages/Cnt/Bright.vue";

//SPBG
import SPBG from "@/views/pages/SPBG/SPBG.vue";
import SPBGReport from "@/views/pages/SPBG/SPBGReport.vue";

//B2B
import B2B from "@/views/pages/B2B/B2B.vue";
import B2BReport from "@/views/pages/B2B/B2BReport.vue";

//SPKLU
import SPKLU from "@/views/pages/SPKLU/SPKLU.vue";
import SPKLUReport from "@/views/pages/SPKLU/SPKLUReport.vue";

//PPOB
import PPOB from "@/views/pages/PPOB/PPOB.vue";
import PPOBReport from "@/views/pages/PPOB/PPOBReport.vue";

//PropertyManagement
import PropertyManagement from "@/views/pages/PropertyManagement/PropertyManagement.vue";
import PropertyManagementReport from "@/views/pages/PropertyManagement/PropertyManagementReport.vue";
//import NFR from '@/views/pages/Nfr/nfr.vue'

//AutoCare
import AutoCare from "@/views/pages/AutoCare/AutoCare.vue";
import AutoCareReport from "@/views/pages/AutoCare/AutoCareReport.vue";

//Cash Deposit
import FinanceCashDeposit from "@/views/pages/Finance/CashDeposit/CashDeposit.vue";
import FinanceCashDepositReport from "@/views/pages/Finance/CashDeposit/Report/Report.vue";
import FinanceCashDepositTodaySummary from "@/views/pages/Finance/CashDeposit/Report/TodaySummary.vue";
import FinanceCashDepositDayEnd from "@/views/pages/Finance/CashDeposit/Report/DayEnd.vue";
import FinanceCashDepositBagReplacement from "@/views/pages/Finance/CashDeposit/Report/BagReplacement.vue";
import FinanceCashDepositDenomSummary from "@/views/pages/Finance/CashDeposit/Report/DenomSummary.vue";

//Business Tracking
import BusinessTracking from "@/views/pages/BusinessTracking/BusinessTracking.vue";

//Post Mortem
import PostMortem from "@/views/pages/PostMortem/PostMortem.vue";
import PostMortemReport from "@/views/pages/PostMortem/PostMortemReport.vue";
import PostMortemOverview from "@/views/pages/PostMortem/Performance/Overview.vue";
import PostMortemWaterfall from "@/views/pages/PostMortem/Performance/Waterfall.vue";
import PostMortemPerformance from "@/views/pages/PostMortem/Performance/Overview.vue";

//Business Unit
import BusinessUnit from "@/views/pages/BusinessUnit/BusinessUnit.vue";
import BusinessUnitDetail from "@/views/pages/BusinessUnit/BusinessUnitDetail.vue";

import GPMandalika from "@/views/pages/MandalikaGP.vue";

import FuelSalesTracking from "@/views/pages/FuelTracking/FuelTrackingSalesRkap.vue";
import FuelSalesTrackingValue from "@/views/pages/FuelTracking/FuelTrackingSalesValue.vue";
import FuelSalesTrackingVolume from "@/views/pages/FuelTracking/FuelTrackingSalesVolume.vue";
import FuelSalesTrackingSpd from "@/views/pages/FuelTracking/FuelTrackingSalesSpd.vue";

import PettyCash from "@/views/pages/Finance/PettyCash/PettyCash.vue";
import PettyCashReport from "@/views/pages/Finance/PettyCash/Report/PettyCashReport.vue";

//Maintenance Posting BOS
import PostingBos from "@/views/pages/Maintenance/PostingBos/PostingBos.vue";
import PostingBosReport from "@/views/pages/Maintenance/PostingBos/PostingBosReport/PostingBosReport.vue";

import Login from "@/views/pages/Login.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Overview",
        component: Overview,
    },

    //Login
    {
        path: "/login",
        name: "Login",
        component: Login,
    },

    //Business Unit
    {
        path: "/business-unit",
        name: "BusinessUnit",
        component: BusinessUnit,
    },

    //Business Unit Detail
    {
        path: "/business-unit/detail",
        name: "BusinessUnitDetail",
        component: BusinessUnitDetail,
    },

    //SPBG
    {
        path: "/spbg",
        name: "SPBG",
        component: SPBG,
        children: [
            {
                path: "/spbg/report",
                name: "Report",
                component: SPBGReport,
            },
        ],
    },

    {
        path: "/customer",
        name: "Customer",
        component: Customer,
        children: [
            {
                path: "/customer/complaint",
                name: "CustomerComplaint",
                component: CustomerComplaint2,
            },
            {
                path: "/customer/complaintold",
                name: "CustomerComplaintOld",
                component: CustomerComplaint,
            },
            {
                path: "/customer/report",
                name: "CustomerReport",
                component: CustomerReport3, //CustomerReport2
            },
            {
                path: "/customer/reportold",
                name: "CustomerReportOld",
                component: CustomerReport,
            },
            {
                path: "/customer/sinergi",
                name: "Sinergi",
                component: CustomerSinergi,
            },
        ],
    },
    {
        path: "/fuel",
        name: "Fuel",
        component: Fuel,
        children: [
            {
                path: "/fuel/outlet",
                name: "FuelOutlet",
                component: FuelOutlet2, //FuelOutlet
            },
            {
                path: "/fuel/report2",
                name: "FuelReport",
                component: FuelReport,
            },
            {
                path: "/fuel/reportold",
                name: "FuelReportOld",
                component: FuelReport2,
            },
            {
                path: "/fuel/coco",
                name: "Coco",
                component: FuelCoco,
            },
            {
                path: "/fuel/kso",
                name: "Kso",
                component: FuelKso,
            },
            {
                path: "/fuel/tac",
                name: "Tac",
                component: FuelTac,
            },
            {
                path: "/fuel/margin-tac",
                name: "MarginTAC",
                component: FuelMarginTac,
            },
            /*
            {
                path:'/fuel/fuel-tracking',
                name:'BusinessFuelTracking',
                component:FuelTracking
            },
            */
            {
                path: "/fuel/jbt",
                name: "JBT",
                component: FuelJBT,
            },
            {
                path: "/fuel/do-outstanding",
                name: "DO Outstanding",
                component: FuelDOOutstanding,
                children: [
                    {
                        path: "/fuel/do-outstanding/report",
                        name: "ReportDOOutstanding",
                        component: FuelDOOutstandingReport,
                    },
                ],
            },
        ],
    },

    //B2B
    {
        path: "/b2b",
        name: "B2B",
        component: B2B,
        children: [
            {
                path: "/b2b/report",
                name: "ReportB2B",
                component: B2BReport,
            },
        ],
    },

    //SPKLU
    {
        path: "/spklu",
        name: "SPKLU",
        component: SPKLU,
        children: [
            {
                path: "/spklu/report",
                name: "ReportSPKLU",
                component: SPKLUReport,
            },
        ],
    },

    //PPOB
    {
        path: "/ppob",
        name: "PPOB",
        component: PPOB,
        children: [
            {
                path: "/ppob/report",
                name: "ReportPPOB",
                component: PPOBReport,
            },
        ],
    },

    //PropertyManagement
    {
        path: "/property-management",
        name: "PropertyManagement",
        component: PropertyManagement,
        children: [
            {
                path: "/property-management/report",
                name: "ReportPropertyManagement",
                component: PropertyManagementReport, //PropertyManagementReport, //NFR,
            },
        ],
    },

    //AutoCare/BOM
    {
        path: "/autocare",
        name: "Autocare",
        component: AutoCare,
        children: [
            {
                path: "/autocare/report",
                name: "ReportAutoCare",
                component: AutoCareReport,
            },
        ],
    },

    {
        path: "/bright",
        name: "Bright",
        component: Bright,
        children: [
            {
                path: "/bright/storelist",
                name: "BrightStoreList",
                component: BrightStoreList,
            },
            {
                path: "/bright/store",
                name: "BrightStore",
                component: BrightStore,
            },
            {
                path: "/bright/sales",
                name: "BrightSales",
                component: BrightSales,
            },
            {
                path: "/bright/performance",
                name: "BrightPerformance",
                component: BrightPerformance,
            },
            {
                path: "/bright/stock",
                name: "BrightStock",
                component: BrightStock,
            },
            {
                path: "/bright/sl",
                name: "ServiceLevel",
                component: BrightSL,
            },
            {
                path: "/bright/baseline",
                name: "BaselineComparison",
                component: BaselineComparison,
            },
            {
                path: "/bright/report2",
                name: "BrightReport2",
                component: BrightReport2, //BrightReport
            },
            {
                path: "/bright/report",
                name: "BrightReport",
                component: BrightReport2,
            },
            {
                path: "/bright/item",
                name: "DashboardItem",
                component: DashboardItem,
            },
            {
                path: "/bright/store-performance",
                name: "Performance",
                component: BrightStorePerformance,
            },
            {
                path: "/bright/other-income",
                name: "OtherIncome ",
                component: BrightOtherIncome,
            },
            /*
            {
                path:'/bright/bright-store-tracking',
                name:'BusinessStoreTracking',
                component:BrightStoreTracking,
            },
            */
        ],
    },
    {
        path: "/cafe",
        name: "Cafe",
        component: Cafe,
        children: [
            {
                path: "/cafe/cafelist",
                name: "CafeList",
                component: CafeList,
            },
            {
                path: "/cafe/sales",
                name: "CafeSales",
                component: CafeSales,
            },
            {
                path: "/cafe/report",
                name: "CafeReport",
                component: CafeReport,
            },
        ],
    },
    {
        path: "/hsse",
        name: "HSSE",
        component: HSSE,
        children: [
            {
                path: "/hsse/action-tracking",
                name: "ActionTracking",
                component: HSSEActionTracking,
            },
        ],
    },
    {
        path: "/maintenance",
        name: "Maintenance",
        component: Maintenance, //Maintenance // Maintenance Report
        children: [
            {
                path: "/maintenance/posting-bos",
                name: "PostingBos",
                component: PostingBos,
                children: [
                    {
                        path: "/maintenance/posting-bos/report",
                        name: "PostingBosReport",
                        component: PostingBosReport,
                    },
                ],
            },
            {
                path: "/maintenance/report",
                name: "ReportMaintenance",
                component: MaintenanceReport2,
            },
            {
                path: "/maintenance/operation",
                name: "Operation",
                component: MaintenanceOperation,
            },
        ],
    },
    {
        path: "/maintenance-monitor",
        name: "MaintenanceMonitor",
        component: MaintenanceReportVendor,
    },
    {
        path: "/lpg",
        name: "LPG",
        component: LPG,
        children: [
            {
                path: "/lpg/keagenan",
                name: "LPGKeagenan",
                component: LPGKeagenan,
            },
            {
                path: "/lpg/report",
                name: "LPGReport",
                component: LPGReport2,
            },
            {
                path: "/lpg/BrimolaClearing",
                name: "BrimolaClearing",
                component: BrimolaClearing,
            },
            {
                path: "/lpg/KliringVAPangkalanLPG",
                name: "KliringVAPangkalanLPG",
                component: KliringVAPangkalanLPG,
            },
            {
                path: "/lpg/reportold",
                name: "LPGReportOld",
                component: LPGReport,
            },
        ],
    },
    {
        path: "/supply-chain",
        name: "SupplyChain",
        component: SupplyChain,
        children: [
            {
                path: "/supply-chain/report",
                name: "SupplyChainReport",
                component: SupplyChainReport,
            },
            {
                path: "/supply-chain/item-quota",
                name: "ReportItemQuota",
                component: SupplyChainItemQuotaReport,
            },
        ],
    },
    {
        path: "/Piutang",
        name: "Piutang",
        component: Piutang,
    },
    {
        path: "/vendor",
        name: "Vendor",
        component: Vendor,
        children: [
            {
                path: "/vendor/report",
                name: "VendorReport",
                component: VendorReport,
            },
        ],
    },
    {
        path: "/merchandise",
        name: "Merchandise",
        component: Merchandise,
        children: [
            {
                path: "/merchandise/report",
                name: "MerchandiseReport",
                component: MerchandiseReport,
            },
        ],
    },
    {
        path: "/hrga",
        name: "HRGA",
        component: Hrga,
        children: [
            {
                path: "/hrga/report",
                name: "HrgaReport",
                component: HrgaReport,
            },
        ],
    },
    /*
    {
        path:'/finance',
        name:'Finance',
        component:Finance
    },
	*/
    {
        path: "/financereport",
        name: "FinancialReport", //FinanceReport
        component: FinanceReport2, //FinanceReport
        /*
        children:[
            {
                path:'/financereport/treasury',
                name:'Treasury',
                component:Treasury,
            },
        ] */
    },

    {
        path: "/satgas",
        name: "Satgas",
        component: Satgas,
        children: [
            {
                path: "/satgas/report",
                name: "SatgasReport",
                component: SatgasReport2,
            },
        ],
    },
    {
        path: "/satgas-monitor",
        name: "Monitor Satgas",
        component: SatgasMonitorVendor,
    },

    //Satgas CNT
    /*
    {
        path:'/satgas-cnt',
        name:'SatgasCNT',
        component:SatgasReportCNT, //SatgasCNT,
        children:[
            {
                path:'/satgas-cnt/report',
                name:'SatgasCNTReport',
                component:SatgasReportCNT
            },
        ]
    },
    */

    //Post Mortem
    {
        path: "/post-mortem",
        name: "PostMortem",
        component: PostMortem, //PostMortemReport, //PostMortem,,PostMortemPerformance
        children: [
            {
                id: "post-mortem-overview",
                path: "/post-mortem/overview",
                name: "Overview",
                component: PostMortemOverview,
            },
            {
                id: "post-mortem-waterfall",
                path: "/post-mortem/waterfall",
                name: "Waterfall",
                component: PostMortemWaterfall,
            },
            {
                id: "post-mortem-performance",
                path: "/post-mortem/performance",
                name: "Performance",
                component: PostMortemPerformance,
            },

            {
                path: "/post-mortem/report",
                name: "PostMortemReport",
                component: PostMortemReport,
            },
        ],
    },
    {
        path: "/plant",
        name: "Plant",
        component: Plant,
    },
    {
        path: "/plantSatgas",
        name: "PlantSatgas",
        component: PlantSatgas,
    },
    {
        path: "/plant-satgas-monitor",
        name: "PlantSatgasVendor",
        component: PlantSatgasVendor,
    },
    {
        path: "/plantStation",
        name: "PlantStation",
        component: PlantStation,
    },
    {
        path: "/treasury",
        name: "Treasury",
        component: Treasury,
        children: [
            {
                path: "/treasury/income",
                name: "Penerimaan",
                component: TreasuryIncome,
            },
            {
                path: "/treasury/outcome",
                name: "Pengeluaran",
                component: TreasuryOutcome,
            },
        ],
    },

    {
        path: "/treasury-overview",
        name: "TreasuryOverview",
        component: TreasuryOverview,
        children: [
            {
                path: "/treasury/cash-flow",
                name: "CashFlow",
                component: TreasuryCashFlow,
            },
            {
                path: "/treasury/daily-balance",
                name: "SaldoHarian",
                component: TreasuryDailyBalance,
            },
        ],
    },

    {
        path: "/performance-report",
        name: "PerformanceReport",
        component: PerformanceMainPage,
        children: [
            {
                path: "/performance-report/intro",
                name: "Present",
                component: PencapaianPertumbuhanIntro,
            },

            {
                path: "/performance-report/fuel-retail",
                name: "PertumbuhanFuelRetail",
                component: PencapaianPertumbuhanOutlet,
            },

            {
                path: "/performance-report/sales-losses",
                name: "SalesVolumeAndLosses",
                component: PerformanceSalesAndLosses,
            },
            {
                path: "/performance-report/profit-laba",
                name: "ProfitAndLaba",
                component: PerformanceProfitAndLaba,
            },

            {
                path: "/performance-report/non-fuel-retail",
                name: "PertumbuhanNonFuelRetail",
                component: PencapaianPertumbuhanOutletNonFuel,
            },
            {
                path: "/performance-report/sales-volume",
                name: "PerformanceSalesVolume",
                component: PerformanceSalesVolume,
            },
            {
                path: "/performance-report/losses-by-product",
                name: "LossesByProduct",
                component: PerformanceLossesByProduct,
            },
            {
                path: "/performance-report/konsolidasi",
                name: "Konsolidasi",
                component: PerformanceKeuanganKosolidasi,
            },
            {
                path: "/performance-report/revenue-and-laba",
                name: "RevenueLaba",
                component: PerformanceRevenueLaba,
            },
            {
                path: "/performance-report/financial-fuel-business",
                name: "FinancialFuelBusiness",
                component: PerformanceKinerjaFinancial,
            },
            {
                path: "/performance-report/financial-non-fuel-business",
                name: "FinancialNonFuelBusiness",
                component: PerformanceKinerjaFinancialNonFuel,
            },
            {
                path: "/performance-report/tingkat-kesehatan",
                name: "TingkatKesehatan",
                component: PerformanceTingkatKesehatan,
            },

            {
                path: "/performance-report/rasio-keuangan",
                name: "RasioKeuangan",
                component: PerformanceRasioKeuangan,
            },
            {
                path: "/performance-report/realisasi-abo",
                name: "RealisasiABO",
                component: PerformanceRealisasiABO,
            },
            {
                path: "/performance-report/realisasi-capex",
                name: "RealisasiCAPEX",
                component: PerformanceRealisasiCAPEX,
            },
            {
                path: "/performance-report/end-present",
                name: "EndPresent",
                component: PencapaianPertumbuhanEnd,
            },
        ],
    },

    //Finance Group
    {
        path: "/finance",
        name: "FinanceGroup",
        component: FinancialGroupOverview,
        children: [
            {
                path: "/finance/cash-deposit",
                name: "ReportFinanceGroupCashDeposit",
                component: FinanceCashDeposit,
                children: [
                    {
                        path: "/finance/cash-deposit/report",
                        name: "ReportCashDeposit",
                        component: FinanceCashDepositReport,
                    },
                    {
                        path: "/finance/cash-deposit/today-summary",
                        name: "Today Summary",
                        component: FinanceCashDepositTodaySummary,
                    },
                    {
                        path: "/finance/cash-deposit/day-end",
                        name: "Day End",
                        component: FinanceCashDepositDayEnd,
                    },
                    {
                        path: "/finance/cash-deposit/bag-replacement",
                        name: "Bag Replacement",
                        component: FinanceCashDepositBagReplacement,
                    },
                    {
                        path: "/finance/cash-deposit/denom-summary",
                        name: "Denom Summary",
                        component: FinanceCashDepositDenomSummary,
                    },
                ],
            },

            {
                id: "finance-group-pettycash",
                path: "/finance/pettycash",
                name: "Petty Cash",
                component: PettyCash,
                children: [
                    {
                        id: "finance-group-pettycash-report",
                        path: "/finance/pettycash/report",
                        name: "Petty Cash Report",
                        component: PettyCashReport,
                    },
                ],
            },

            {
                path: "/finance/pl-unit",
                name: "ReportFinanceGroupPLUnit",
                component: PLUnit,
                children: [
                    {
                        path: "/finance/pl-unit/volume-real-vs-rkap",
                        name: "VolumeRealVSRKAP",
                        component: PLUnitVolumeVSRKAP,
                    },
                    {
                        path: "/finance/pl-unit/laporan-manajemen",
                        name: "Laporan Manajemen 2", //Volume Real VS RKAP
                        component: PLUnitLaporanManajemen,
                    },
                    {
                        path: "/finance/pl-unit/report",
                        name: "ReportFinanceGroupPLUnitReport",
                        component: PLUnitReport,
                    },
                ],
            },
        ],
    },

    {
        path: "/finance/report-group",
        name: "ReportFinanceGroup",
        component: FinancialReportGroup,
    },

    {
        path: "/finance/monitoring-cogs",
        name: "MonitoringCogsFinanceGroup",
        component: FinanceMonitoringCogs,
    },

    //FOR CNT
    {
        path: "/overview-cnt",
        name: "OverviewCnt",
        component: OverviewCnt,
    },

    {
        path: "/bright-cnt",
        name: "BrightCnt",
        component: BrightCnt,
        children: [
            {
                path: "/bright/storelist-cnt",
                name: "BrightStoreListCnt",
                component: BrightStoreList,
            },
            {
                path: "/bright/store-cnt",
                name: "BrightStoreCnt",
                component: BrightStore,
            },
            {
                path: "/bright/baseline-cnt",
                name: "BaselineComparisonCnt",
                component: BaselineComparisonCnt,
            },
            {
                path: "/bright/report-cnt",
                name: "BrightReportCnt",
                component: BrightReportCnt, //BrightReport
            },
        ],
    },
    //END FOR CNT

    //FOR CNT
    /*
    {
        path:'/nfr',
        name:'nfr',
        component:NFR
    },
    */

    //Business Tracking
    {
        path: "/business-tracking",
        name: "BusinessTracking",
        component: BusinessTracking,
        children: [
            {
                path: "/business-tracking/fuel",
                name: "FuelTracking",
                component: FuelTracking,
            },
            {
                path: "/business-tracking/bright-store",
                name: "BrightStoreTracking",
                component: BrightStoreTracking,
            },
            {
                path: "/business-tracking/sales-tracking",
                name: "SalesTracking",
                component: FuelSalesTracking,
                children: [
                    {
                        path: "/business-tracking/sales-tracking/value",
                        name: "SalesValue",
                        component: FuelSalesTrackingValue,
                    },
                    {
                        path: "/business-tracking/sales-tracking/volume",
                        name: "SalesVolume",
                        component: FuelSalesTrackingVolume,
                    },
                    {
                        path: "/business-tracking/sales-tracking/spd",
                        name: "SPD",
                        component: FuelSalesTrackingSpd,
                    },
                ],
            },
        ],
    },

    {
        path: "/gp-mandalika",
        name: "GPMandalika",
        component: GPMandalika,
    },

    {
        path: "/overview",
        name: "OverviewMonitor",
        //component:GPMandalika,
    },

    {
        path: "*",
        component: PageNotFound,
        name: "PageNotFound",
    },
];

export default new VueRouter({
    mode: "history",
    routes: routes,
});
